import { Trans } from 'react-i18next';

import { Modal, ModalConfirmButton, ModalWidth, StrongText, Text } from '@dreryk/react-components';

import { visitDetailsTranslationKeys } from '../../../../../../translations';

import { RemovalChronicDiseaseForm } from './RemovalChronicDiseaseForm';
import { ChronicDiseaseRemovalParameters, ChronicDiseaseRemovalState } from './RemovalChronicDiseaseModal.types';

export type RemovalChronicDiseaseModalSubmitHandler = (parameters: ChronicDiseaseRemovalParameters) => void;

type RemovalChronicDiseaseModalProps = {
   readonly onClose: VoidFunction;
   readonly onSubmit: RemovalChronicDiseaseModalSubmitHandler;
   readonly chronicDiseaseToRemoval: ChronicDiseaseRemovalState;
   readonly visitBeginDate: Date;
};

export const RemovalChronicDiseaseModal = (props: RemovalChronicDiseaseModalProps): JSX.Element => {
   return (
      <Modal
         title={visitDetailsTranslationKeys.diagnoses.removalChronicDisease.modal.title}
         width={ModalWidth.NORMAL}
         onCloseRequest={props.onClose}
         onCancel={props.onClose}
         testId='removalChronicDiseaseModal'
      >
         <Text testId={'confirmationRemovalMessage'}>
            <Trans
               i18nKey={visitDetailsTranslationKeys.diagnoses.removalChronicDisease.modal.message}
               values={{
                  name: props.chronicDiseaseToRemoval.fault.name,
                  code: props.chronicDiseaseToRemoval.fault.icd10Code,
               }}
               components={{ bold: <StrongText testId={'diseaseCodeAndName'} /> }}
            />
         </Text>

         <RemovalChronicDiseaseForm visitBeginDate={props.visitBeginDate}>
            {({ handleSubmit }) => (
               <ModalConfirmButton
                  label={visitDetailsTranslationKeys.diagnoses.removalChronicDisease.modal.confirm.label}
                  onClick={handleSubmit(({ chronicDiseaseRemovalReason, chronicDiseaseRemovalDate }) => {
                     props.onSubmit({
                        chronicDiseaseRemovalReason: chronicDiseaseRemovalReason,
                        chronicDiseaseRemovalCode: props.chronicDiseaseToRemoval.fault.icd10Code,
                        chronicDiseaseRemovalDate: chronicDiseaseRemovalDate,
                     });
                  })}
               />
            )}
         </RemovalChronicDiseaseForm>
      </Modal>
   );
};
